import React from "react";
import {LogoutOutlined} from "@ant-design/icons";
import {Button} from "antd";
import type {MenuProps} from "antd";
import {sso} from "helper/sso";
import {data} from "data/env";
import {clearLocalStorageExceptKey} from "helper/auth";
import { tabKeys } from "types/enums";

const _sso = new sso({
  realmUrl: data.sso_url,
  clientId: data.sso_clientid,
  callbackUrl: data.client_callback_url,
  logoutCallbackUrl: data.client_logout_url,
});
const signOut = () => {
  var idToken = localStorage.getItem("idToken");
  var urlLogOutSSO = _sso.logoutUrl(idToken, data.client_logout_url);
  clearLocalStorageExceptKey([
    "RECEIVED_TABLE",
    "NURSE_OUT_TABLE",
    "TECHNICAL_SERVICE_TABLE",
    tabKeys.REFRACTION.REFRACTION_LIST,
    "khoUserId",
    "khoUserGlassId",
    "khoVTYTQuanLyLocal",
    "phongKham",
  ]);
  // window.location.replace("/login");
  window.location.replace(urlLogOutSSO);
};
const items: MenuProps["items"] = [
  {
    key: "1",
    label: (
      <Button onClick={signOut} icon={<LogoutOutlined rev={undefined} />}>
        {" "}
        Đăng xuất
      </Button>
    ),
  },
];

export {items, signOut};
